import { useCommunityContext } from 'providers';
import { useMemo } from 'react';

import { useCurrentUserCommunityMembershipQuery } from 'shared/graphql';
import { useCurrentUser } from 'shared/hooks';

/**
 * Fetch and return the current user's membership in the selected community.
 * The hook combines user and community context, and queries for the user's membership in the selected community.
 * @see https://github.com/jebelapp/jebel/issues/1841
 */
export function useCurrentUserCommunityMembership() {
  const { user, loading: userLoading } = useCurrentUser();
  const { selectedCommunity: school, loading: schoolLoading } = useCommunityContext();

  const { data, loading } = useCurrentUserCommunityMembershipQuery({
    skip: !user || !school,
    fetchPolicy: 'cache-first',
    variables: {
      community: school?.id as string,
    },
  });

  const membership = useMemo(() => {
    // Memoize the membership data for performance
    return data?.user?.memberships?.items?.[0] ?? null;
  }, [data, user, school]);

  return {
    data: membership,
    loading: userLoading || schoolLoading || loading,
  };
}
